import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import { checkIsLoggedIn, checkIsLoginError, loginUser } from "./authSlice";
import { useSelector, useDispatch } from "react-redux";
import { ThemeProvider } from "@mui/material/styles";
import { getUserGroups, checkSessionChecked } from "./authSlice";
import { ReactComponent as SvgFile } from "../../Global/images/tjommie.svg";
import theme from "../../Global/theme";
import config from "../../config";
export default function LogIn(props) {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const isLoggedin = useSelector(checkIsLoggedIn);
  const isLoginError = useSelector(checkIsLoginError);
  const user_groups = useSelector(getUserGroups);
  // Someone already signed in is sent to an app by their roles; wait for the refreshed ones.
  const sessionChecked = useSelector(checkSessionChecked);

  let password_reset_url = `${config.REACT_APP_LOGIN}/auth/password_reset/`;

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    dispatch(loginUser({ email: data.get("email"), password: data.get("password") }));
  };

  useEffect(() => {
    if (isLoggedin && sessionChecked) {
      if (user_groups.includes("dsm_qe")) {
        navigate("/QE/");
      }
      // Before the installer branch: a field admin can also hold dsm_installer, and the
      // Field Admin app is the more specific home of the two.
      else if (user_groups.includes("dsm_field_admin")) {
        navigate("/field-admin/");
      } else if (
        user_groups.includes("dsm_installer") ||
        user_groups.includes("neura_ims_admin")
      ) {
        navigate("/installer/");
      } else if (
        user_groups.includes("dsm_operator") ||
        user_groups.includes("dsm_operator_view_only")
      ) {
        navigate("/");
      } else if (user_groups.includes("dsm_municipality")) {
        navigate("/municipality/");
      } else {
        navigate("/");
      }
    }
  }, [isLoggedin, isLoginError, sessionChecked]);

  return (
    <>
      <div className="center-login">
        <ThemeProvider theme={theme}>
          <Container component="main" maxWidth="xs">
            <CssBaseline />
            <Card
              sx={{
                backgroundColor: "#161B22",
                border: "1px solid rgba(255,255,255,0.07)",
                borderRadius: "16px",
                boxShadow: "0 24px 48px rgba(0,0,0,0.4)",
              }}
            >
              <CardContent sx={{ p: 3 }}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <SvgFile />
                  <br />
                  <Box
                    component="form"
                    onSubmit={handleSubmit}
                    noValidate
                    sx={{ width: "100%" }}
                  >
                    <TextField
                      margin="normal"
                      required
                      fullWidth
                      id="email"
                      label="Email Address"
                      name="email"
                      autoComplete="email"
                      autoFocus
                    />
                    <TextField
                      margin="normal"
                      required
                      fullWidth
                      name="password"
                      label="Password"
                      type="password"
                      id="password"
                      autoComplete="current-password"
                    />
                    <Collapse in={isLoginError}>
                      <Alert
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                          />
                        }
                        sx={{ mb: 2 }}
                        severity="error"
                      >
                        Invalid email or password!
                      </Alert>
                    </Collapse>
                    <br />
                    <Button
                      type="submit"
                      fullWidth
                      variant="contained"
                      sx={{
                        backgroundColor: "#FDB940",
                        color: "#000",
                        fontWeight: 700,
                        py: 1.4,
                        borderRadius: "10px",
                        fontSize: "1rem",
                        "&:hover": { backgroundColor: "#e6a832" },
                      }}
                    >
                      Sign In
                    </Button>
                    <br />
                    <br />
                    <Typography
                      component="a"
                      href={password_reset_url}
                      sx={{
                        color: "rgba(255,255,255,0.5)",
                        fontSize: "0.85rem",
                        textDecoration: "none",
                        "&:hover": { color: "#FDB940" },
                      }}
                    >
                      Forgot Password?
                    </Typography>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Container>
        </ThemeProvider>
      </div>
    </>
  );
}
